/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useMemo, useState, useEffect } from "react";
import { useStateStorage } from "../hooks/use-state-storage";

export const AppContext = createContext();

export function AppContextProvider({ children }) {
  // const [store, setStore] = useState({
  //   mode: "light",
  // });
  const [theme, setTheme] = useStateStorage("theme");
  const [language, setLanguage] = useStateStorage("language");
  const [selectedFactory, setSelectedFactory, removeSelectedFactory] =
    useStateStorage("selectedFactory");
  const [selectedRoles, setSelectedRoles, removeSelectedRoles] = useStateStorage("selectedRoles");

  const [actions, setActions] = useState({
    changeTheme: (mode) => setTheme(mode),
  });

  // Update localization when selectedFactory changes
  // We watch selectedFactory?.name specifically because that's what determines the tenant
  useEffect(() => {
    // Add a small delay to ensure localStorage is updated
    const timer = setTimeout(async () => {
      
      // Get the new tenant based on selectedFactory
      const newTenant = selectedFactory?.name?.toLowerCase() === "insider 2" ? "insider" : "experilabs";
      const currentTenant = window.i18nCurrentTenant || "experilabs";
      
      
      // If tenant changed, refresh the page to load new localization
      if (currentTenant !== newTenant) {
        window.location.reload();
      } 
    }, 100);
    
    return () => clearTimeout(timer);
  }, [selectedFactory?.name, selectedFactory?.id]);



  const context = useMemo(
    () => ({
      actions,
      setActions,
      theme,
      setTheme,
      language,
      setLanguage,
      selectedFactory,
      setSelectedFactory,
      removeSelectedFactory,
      selectedRoles,
      setSelectedRoles,
      removeSelectedRoles,
    }),
    [
      actions,
      setActions,
      theme,
      setTheme,
      language,
      setLanguage,
      selectedFactory,
      setSelectedFactory,
      removeSelectedFactory,
      selectedRoles,
      setSelectedRoles,
      removeSelectedRoles,
    ]
  );

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
}
